module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/mmuskel2-404bb2d31d74a9152d0af322720eab4c.jpg";